import type { AlertBannerProps } from '../../../react4xp/parts/alertBanner/AlertBannerProps.d';

import React from 'react';
import { AlertBanner } from '/react4xp/parts/alertBanner/AlertBanner';


export default function (props: AlertBannerProps): React.JSX.Element {
	return <AlertBanner {...props} />;
}
